import React, { ReactNode } from 'react';
import { twMerge } from 'utilities/src/twMerge';
import CardImage from './CardImage';
import CardContainer from './CardContainer';
import CardCategory from './CardCategory';
import CardTitle from './CardTitle';
import CardSummary from './CardSummary';
import CardFooter from './CardFooter';
import CardMinutesRead from './CardMinutesRead';

type CardProps = {
  children: ReactNode;
  classes?: string;
};

export function CardComponent({ children, classes = '' }: CardProps) {
  return <div className={twMerge('z-0 bg-white', classes)}>{children}</div>;
}

const Card = Object.assign(CardComponent, {
  Image: CardImage,
  Container: CardContainer,
  Category: CardCategory,
  Title: CardTitle,
  Summary: CardSummary,
  Footer: CardFooter,
  MinutesRead: CardMinutesRead,
});

export default Card;
